// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component
import PPcontent from './PageComponent/PPcontent';

function PrivacyPolicy() {

    useMeta({
        title: 'Privacy Policy | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/privacy-policy/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Privacy Policy | Callistus Blinds',
            description:
                'CALLISTUS IS A PRIVATE, COPYRIGHTED SITE AND INTENDED SOLELY FOR PERSONAL USE CATEGORIES OF INFORMATION, Information about you can be categorized as (a) personally identifiable information, or (b) non-personally identifiable information. “Personally identifiable information” is information that we collect from you such as your name, postal address, phone number, fax number and email address. “Non-personally identifiable information” is information that we collect from you that does not include your name or any information that would allow us to contact you.',
            url: 'https://callistusblinds.com/privacy-policy/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <PPcontent />
            <Footer />
        </div>
    );
}

export default PrivacyPolicy;
